import { preloadImages } from './preloadImg'

/**
 * 懒加载 bonus-reward 弹窗所需图片（非阻塞，利用浏览器空闲时机）
 */
export function preloadBonusRewardPics() {
  // webpack 在构建时将路径解析为带 hash 的静态资源 URL
  // 只有开启了 bonus-reward 的游戏（kingshot/wos）才会 require 此文件
  let IMAGES = []
  try {
    IMAGES = [
      require('@gameImg/bonus_reward/bg-mobile.png'),
      require('@gameImg/bonus_reward/btn-mobile.png'),
      require('@gameImg/bonus_reward/bg-pc.png'),
      require('@gameImg/bonus_reward/btn-pc.png'),
    ]
  } catch (error) {}
  preloadImages(IMAGES)
}
